//TopShot用フロント
import React from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider } from '@chakra-ui/react';


import { v4 as uuidv4 } from 'uuid';
import { Routes,Route,HashRouter,useNavigate} from 'react-router-dom';
import { RecoilRoot , useRecoilState} from 'recoil';
import { languageInit } from "./core/i18";
import { useTranslation } from 'react-i18next';
import { nftAbi } from "./core/nftAbi";
import { getConfigJson, getMobileOS } from "./usecases/repositories/common";
import { getNFTinfoTopShotV5, mintNFTTopShot } from "./usecases/repositories/topShot";


import { ConfigJsonType } from "./model/configJsonType";

import { nftJsonState } from "./states/nftJsonState";
import { nftJsonNoneMetaState } from "./states/nftJsonNoneMetaState";
import { configJsonState } from "./states/configJsonState";
import { requestIdState } from "./states/requestIdState";

import { useInitialLanguageSetting } from "./usecases/hooks/common/useInitialLanguageSetting";

import { IndexPage } from './pages/topShot/indexPage';
import { SelectWalletPage } from './pages/topShot/selectWalletPage';
import { TimeoutPage } from './pages/common/timeoutPage';
import { BackupcardPage } from './pages/topShot/backupcardPage';
import { NFTdisplayPage } from './pages/common/nftdisplayPage';
import { MyPage } from './pages/common/myPage';
import { UseNFTBackupcardPage } from './pages/common/usenftBackupcardPage';
import { NFTRecievePage } from './pages/common/nftrecievePage';
import { PushNotificationPage } from './pages/common/pushNotificationPage';
import { OverLimitPerWalletPage } from './pages/common/overLimitPerWalletPage';
import { UsedMintBrowserTabPage } from './pages/common/usedMintBrowserTabPage';
import { MoviePage } from './pages/common/moviePage';
import { ErrorPage } from './pages/common/errorPage';
import { InvalidPage } from './pages/common/invalidPage';
import { DistributionPeriodEndedPage } from './pages/common/distributionPeriodEndedPage';
import { datadogRum } from '@datadog/browser-rum';
import { chainRPCEndpoints } from './core/rpcEndPoits';
import { languageState } from './states/languageState';
import { db, MetaData, NFTItems } from './db/db';
import { NFTCollectionLimitReachedPage } from './pages/common/nftCollectionLimitReachedPage';
import EnquetePage from './pages/topShot/EnquetePage'; 

languageInit();//言語設定初期化

datadogRum.init({//DataDog初期化
  applicationId: '465b6fbb-6da9-4d2d-a9fb-3e8c7ed75653',
  clientToken: 'pub407b02e585f124cfd1f6aab459369c6c',
  site: 'datadoghq.com',
  service:'query-parameter',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 50,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel:'mask-user-input',
  enableExperimentalFeatures: ['clickmap']
})
datadogRum.startSessionReplayRecording();



const App: React.FC<{ compiler: string, framework: string }> = (props) => {
  const [t, i18n] = useTranslation();
  const [nftInfo ,setNFTInfo] = useRecoilState(nftJsonState);
  const [nftInfoNoneMeta,setNftInfoNoneMeta] = useRecoilState(nftJsonNoneMetaState);
  const [configStatus , setConfigStatus] = useRecoilState(configJsonState);
  const [requestIdStatus , setRequestIdStatus] = useRecoilState(requestIdState);
  const [languageStatus , setLanguageStatus] = useRecoilState(languageState);
  const nav = useNavigate();
  const { initializeLanguageSetting } = useInitialLanguageSetting();

  //NFTInfo取得
  React.useEffect(()=>{
    (async() => {
      //初回言語設定
      initializeLanguageSetting();

      if (!requestIdStatus) {
        setRequestIdStatus(uuidv4());
      }

      //unWalletEnterpriseコネクトによる認証ID取得後の配布リクエスト処理
      if (sessionStorage.getItem(`mint_use_unWalletAddress`) && sessionStorage.getItem('MetaForUnWallet') && !sessionStorage.getItem(`mint_request_for_unWallet`)) {
        const result = await mintNFTTopShot(
          sessionStorage.getItem(`mint_use_unWalletAddress`),
          `unWallet`,
          requestIdStatus,
          sessionStorage.getItem('MetaForUnWallet'),
        );
        if (result === `6`) {
          nav(`/${result}`,{state:{useWalletAddress:`${sessionStorage.getItem(`mint_use_unWalletAddress`)}`}});
          sessionStorage.setItem(`mint_request_for_unWallet`,`done`);
          return;
        }else{
          nav(`/${result}`);
          return;
        }  
      }
      //unWalletEnterpriseコネクトからリダイレクトされた場合の処理
      if (window.location.href.indexOf(`#id_token=`) !== -1) {return;}
      
      const result = await getNFTinfoTopShotV5();
      if (result === `12` || result == `14` || result == `15`) {
        nav(`/${result}`);
      }else{
        const useChainInfo = chainRPCEndpoints.find((chain) => chain.chainId === `${result.chain.id}`);
        //from_server
        setNFTInfo({
          name:`${result.metaData.name}`,
          external_url:`${result.metaData.externalUrl}`,
          description:`${result.metaData.description}`,
          image:`${result.metaData.image}`,
          profileicon:``,
          nftmeta:`${result.distPageConfig.meta}`,
          contractaddress:`${result.contract.address}`,
          chainRPCEndpoint:`${useChainInfo.endpointURL}`,
          chainId:`${result.chain.id}`,
          attributes:result.metaData.attributes,
          nftabi:`${JSON.stringify(nftAbi)}`,
        });
        setNftInfoNoneMeta({
          name:`${result.metaData.name}`,
          external_url:`${result.metaData.externalUrl}`,
          description:`${result.metaData.description}`,
          image:`${result.metaData.image}`,
          profileicon:``,
          contractaddress:`${result.contract.address}`,
          chainRPCEndpoint:`${useChainInfo.endpointURL}`,
          chainId:`${result.chain.id}`,
          attributes:result.metaData.attributes,
          nftabi:`${JSON.stringify(nftAbi)}`,
        });

        //設定ファイル情報取得
        let configLang:ConfigJsonType;
        try {
          //from_config.json
          configLang = await getConfigJson();
        } catch (error) {
          if (error instanceof Error) {
            console.log(error.message);
          }
          //from_server
          configLang = {
            lang: result.distPageConfig.lang?result.distPageConfig.lang:`ja`,
            isGachaMovie:result.distPageConfig.isGachaMovie?result.distPageConfig.isGachaMovie:`no`,
            isTweetButton: result.distPageConfig.isTweetButton?result.distPageConfig.isTweetButton:`no`,
            isGetNFTagainButton: result.distPageConfig.isGetNFTagainButton?result.distPageConfig.isGetNFTagainButton:`no`,
            walletTypeArray: (result.distPageConfig.walletTypeArray.length > 0 ) ? result.distPageConfig.walletTypeArray:["browserWallet"],
            insertTweetText: result.distPageConfig.insertTweetText?result.distPageConfig.insertTweetText:``,
            web3layerUrl: result.distPageConfig.web3layerUrl?result.distPageConfig.web3layerUrl:``,
            nftReceivingMovieUrl: result.distPageConfig.nftReceivingMovieUrl?result.distPageConfig.nftReceivingMovieUrl:``,
            nftReceivingImage: {
              url: result.distPageConfig.nftReceivingImage.url?result.distPageConfig.nftReceivingImage.url:``,
              isBlurred: result.distPageConfig.nftReceivingImage.isBlurred?result.distPageConfig.nftReceivingImage.isBlurred:true,
            },
            isMyAppLink: true,
            backgroundImage: result.distPageConfig.backgroundImage?result.distPageConfig.backgroundImage:`https://arweave.net/dk4iegm681EFAvgPECJOBte3kcLcjzCGJAePSo29jsg`,
          }
        }
        setConfigStatus(configLang);
      }
      getMobileOS();
    })();
  },[]);

  React.useEffect(()=>{
    (async() => {
        //初回以降の言語設定
        if (languageStatus.isFirstSetting) {
          i18n.changeLanguage(languageStatus.lang);
        }
    })();
  },[]);

  React.useEffect(()=>{
    (async() => {
      //unWalletEnterpriseコネクトからリダイレクトされた場合の処理
      if (window.location.href.indexOf(`#id_token=`) !== -1) {
        const idToken = window.location.href.split(`#id_token=`)[1];
        const idTokenParts = idToken.split(".");
        const idTokenClaim = JSON.parse(atob(idTokenParts[1]));
        const address      = idTokenClaim.sub;
      
        console.log(`unWalletAddress:${address}`);
        sessionStorage.setItem(`mint_use_unWalletAddress`,`${address}`);
        //リダイレクト
        location.href = window.location.href.split(`#id_token=`)[0] + `?meta=${sessionStorage.getItem('MetaForUnWallet')}`;
      }
    })();
  },[]);

  return (
    <Routes>
      <Route path='/'  element={ <IndexPage /> } />
      <Route path="/1" element={ <SelectWalletPage />} />
      <Route path="/2" element={ <TimeoutPage />} />
      <Route path="/3" element={ <BackupcardPage />} />
      <Route path="/4" element={ <MyPage />}/>
      <Route path="/5" element={ <UseNFTBackupcardPage />} />
      <Route path="/6" element={ <NFTRecievePage />} />
      <Route path="/7" element={ <PushNotificationPage/>}/>
      <Route path="/8" element={ <NFTdisplayPage />} />
      <Route path="/11" element={ <OverLimitPerWalletPage/>} />
      <Route path="/12" element={ <InvalidPage/>}/>
      <Route path="/13" element={ <UsedMintBrowserTabPage/>}/>
      <Route path="/14" element={ <ErrorPage/>}/>
      <Route path="/15" element={ <DistributionPeriodEndedPage/>}/>
      <Route path="/16" element={ <NFTCollectionLimitReachedPage/>}/>
      <Route path="/17" element={ <EnquetePage/>}/>
      <Route path="/movie" element={<MoviePage/>}/>
    </Routes>
  );
}


ReactDOM.render(
  <HashRouter>
    <ChakraProvider resetCSS={true}>
      <RecoilRoot>
        <App compiler="TypeScript" framework="React" />
      </RecoilRoot>
    </ChakraProvider>
  </HashRouter>,
  document.getElementById("root")
);